import React from 'react';
import { Badge, IconButton } from '@mui/material';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { totalUnreadCountSelector } from 'domain/chat';

interface Props {
  onOpen: () => void;
}

const ChatButton: React.FC<Props> = ({ onOpen }) => {
  const count = useSelector(totalUnreadCountSelector);
  const { formatMessage } = useIntl();

  return (
    <IconButton
      color="primary"
      onClick={onOpen}
      aria-label={formatMessage({ id: 'chat.button.openChat', defaultMessage: 'Open chat' })}
      sx={{ '&:hover': { backgroundColor: 'action.hover' } }}
    >
      <Badge color="warning" badgeContent={count}>
        <ChatBubbleOutlineRoundedIcon />
      </Badge>
    </IconButton>
  );
};

export default ChatButton;
